<div class="container-fluid auth">
  <div class="row p-4">
    <img src="assets/img/Logo.svg" class="logo">
  </div>
  <div class="container auth-box">
    <div class="row align-items-center">

      <div class="col-md-6">
        <img src="assets/img/bg-login.png" class="w-100 pr-3"/>
      </div>
      <div class="col-md-6">
        <h2>Welcome!</h2>
        <h4>Contract Management By Sundeus Technology</h4>
        <form [formGroup]="loginForm" (ngSubmit)="login()" class="mt-3">
          <div class="input-field">
            <mat-form-field appearance="outline">
              <mat-label>Email Address</mat-label>
              <input type="text" matInput formControlName="emailAddress" autocomplete="off"
                [errorStateMatcher]="matcher">
              <mat-error *ngIf="loginForm.get('emailAddress').hasError('required')">
                Email Address is required
              </mat-error>
              <mat-error *ngIf="loginForm.get('emailAddress').hasError('email')">
                Please enter a valid Email Address
              </mat-error>
            </mat-form-field>
          </div>
          <div class="input-field">
            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <input type="{{ hidePassword ? 'password' : 'text' }}" matInput autocomplete="off"
                formControlName="password" [errorStateMatcher]="matcher">
              <mat-icon matSuffix (click)="togglePasswordVisibility()" class="cursor-pointer"><ng-icon
                  name="{{ hidePassword ? 'heroEye' : 'heroEyeSlash' }}"></ng-icon></mat-icon>
              <mat-error *ngIf="loginForm.get('password').hasError('required')">
                Password is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="d-flex justify-content-end">
            <a mat-button color="primary" disableRipple [routerLink]="['/forgot-password']">Forgot Password?</a>
          </div>
          <div class="mt-3">
            <button color="accent" mat-raised-button type="submit" class="loading-btn w-100"
              [disabled]="isLoading">
              <span *ngIf="!isLoading">Login</span>
              <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
            </button>
            <div class="mt-2">
              <button mat-raised-button color="primary" type="button" (click)="loginwithMs()" 
              [disabled]="isLoading" class="microsoft-login-btn w-100 d-flex align-items-center justify-content-center">
              <span *ngIf="!isLoading">Login with Microsoft  
                <ng-icon name="microsoft" class="ml-2" size="20px"></ng-icon>
              </span>
              <mat-spinner *ngIf="isLoading" diameter="20" class="microsoft-spinner"></mat-spinner>
            </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>